module.exports = __webpack_public_path__ + "static/media/upload.9baad31b.svg";